(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.querySelector('[data-gallery]');
    var lb = document.querySelector('[data-lightbox]');
    if (!grid || !lb) return;

    var img = lb.querySelector('[data-lb-img]');
    var cap = lb.querySelector('[data-lb-cap]');
    var counter = lb.querySelector('[data-lb-counter]');
    var counterFormat = lb.getAttribute('data-counter-format') || '[current] / [total]';
    var items = [];
    var index = 0;

    function refresh() {
      items = Array.prototype.slice.call(grid.querySelectorAll('[data-gallery-item]'));
    }
    refresh();

    function show(i) {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      var el = items[index];
      img.src = el.getAttribute('data-full');
      var c = el.getAttribute('data-caption') || '';
      cap.textContent = c;
      cap.style.display = c ? '' : 'none';
      counter.textContent = counterFormat.replace('[current]', index + 1).replace('[total]', items.length);
    }
    function open(i) {
      show(i);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-menu-open');
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-menu-open');
      img.src = '';
    }

    grid.addEventListener('click', function (e) {
      var item = e.target.closest('[data-gallery-item]');
      if (!item) return;
      refresh();
      open(items.indexOf(item));
    });

    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { show(index - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { show(index + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-menu-toggle]');
    var closeBtn = document.querySelector('[data-menu-close]');
    var drawer = document.querySelector('[data-mobile-nav]');

    /* Header background on scroll */
    function onScroll() {
      if (!header) return;
      if (window.scrollY > 24) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mobile drawer */
    function openMenu() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      document.body.classList.add('is-menu-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('is-menu-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
    if (toggle) toggle.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeMenu);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    /* Global scroll-reveal */
    function initReveal(scope) {
      var els = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    initReveal(document);

    /* Re-init when sections load in the theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      initReveal(e.target);
      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var v = document.querySelector('[data-hero-video]');
    if (!v) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
